import { getToken } from "../../helpers/common";
import * as apiService from "../api";
import * as API_URL from "../../constants/api";

export const UploadExcludeAudienceData = async (formData) => {
    try {
        const token = getToken();
        const response = await apiService.postWithFormData(API_URL.IVR_ENDPOINT_MANUAL + '/upload-exclude-audience', formData, token);
        return response;
    } catch (err) {
        console.log("Error in UploadExcludeContactsData service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const getExcludedAudienceFileData = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.IVR_ENDPOINT + '/get-excluded-audience', payload, token);
        return response;
    } catch (err) {
        console.log("Error in getExcludedAudienceFileData service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}